import { CaretLeft, CaretRightIcon as CaretRight } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { useClassHelper } from '../../../hooks';
import { Button } from '../../Button';
import { componentName } from '../constants';

interface Props {
  currentPageIndex: number;
  goBackward: () => void;
  goForward: () => void;
  onDismiss: () => void;
  preludePage: boolean;
  totalPages: number;
}

export function Controls({
  currentPageIndex,
  goBackward,
  goForward,
  onDismiss,
  preludePage,
  totalPages,
}: Props) {
  const c = useClassHelper(componentName);
  const isLastPage = currentPageIndex === totalPages - 1;
  const isFirstPage = currentPageIndex === 0;
  const { t } = useTranslation();

  if (preludePage) {
    return (
      <footer className={c('__controls', '__controls--left')}>
        <Button
          type="button"
          classes={{ button: c('__controls__button') }}
          onClick={onDismiss}
          color="secondary"
        >
          {t('components:paginated_slider.dismiss')}
        </Button>
        <Button type="button" onClick={goForward}>
          {t('components:paginated_slider.get_started')}
        </Button>
      </footer>
    );
  }

  return (
    <footer className={c('__controls')}>
      <Button type="button" onClick={goBackward} disabled={isFirstPage}>
        <div className={c('__controls__button')}>
          <CaretLeft size={16} aria-hidden="true" />
          {t('components:paginated_slider.back')}
        </div>
      </Button>
      <Button type="button" onClick={isLastPage ? onDismiss : goForward}>
        <div className={c('__controls__button')}>
          {t(
            isLastPage
              ? 'components:paginated_slider.done'
              : 'components:paginated_slider.next',
          )}
          {!isLastPage && <CaretRight size={16} aria-hidden="true" />}
        </div>
      </Button>
    </footer>
  );
}
